// removed by extract-text-webpack-plugin
module.exports = {"pricing":"Pricing-m__pricing___26BC6","pricing_value":"Pricing-m__pricing_value___3gOCw","pricingValue":"Pricing-m__pricing_value___3gOCw","pricing_originalValue":"Pricing-m__pricing_originalValue___ryHb8","pricingOriginalValue":"Pricing-m__pricing_originalValue___ryHb8","pricing__small":"Pricing-m__pricing__small___31OZQ","pricingSmall":"Pricing-m__pricing__small___31OZQ","pricing__accent":"Pricing-m__pricing__accent___2Fnv2","pricingAccent":"Pricing-m__pricing__accent___2Fnv2"};


//////////////////
// WEBPACK FOOTER
// ./components/pricing/Pricing.m.sass
// module id = rax+
// module chunks = 0